import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, Typography, Alert, Popover, List, theme } from "antd";
import { useNavigate } from 'react-router-dom';
import {
  UserOutlined, LockOutlined, UnlockOutlined, SafetyOutlined, CheckCircleOutlined, CloseCircleOutlined
} from "@ant-design/icons";
import Logo from "../../../assets/logo/logo.svg";
import Limage from "../../../assets/bill.svg";
import AuthRestAPI from '../../../restAPI/AuthRestAPI';

const { Title } = Typography;


const passwordRules = [
  { id: 1, text: "At least 8 characters", pattern: /.{8,}/ },
  { id: 2, text: "At most 15 characters", pattern: /^.{0,15}$/ },
  { id: 3, text: "At least one uppercase letter", pattern: /[A-Z]/ },
  { id: 4, text: "At least one lowercase letter", pattern: /[a-z]/ },
  { id: 5, text: "At least one number", pattern: /\d/ },
  { id: 6, text: "At least one special character", pattern: /[@$!%*?&]/ },
];

const MoguLogin = () => {
  const [password, setPassword] = useState("");
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  const [isTokenAvailable, setIsTokenAvailable] = useState(false);
  const [urlToken, setUrlToken] = useState("");
  const [email, setEmail] = useState("");
  // const [payload, setPayload] = useState({
  //       password: "",
  //       passwordConfirm: "",
  //   });

  const onFinish = () => {
    
  };

  useEffect(() => {
    //get token and email
    if (window.location.href.includes("changepassword?token=")) {
      const parts = window.location.href.split("?");
      const tokenValue =  parts[1].split("token=");
      const emailValue = parts[2].split("email=");
      setUrlToken(tokenValue[1]);
      setEmail(emailValue[1]);
      setIsTokenAvailable(true);
    }
  });

  const {
    token: { colorTextQuaternary },
  } = theme.useToken();

  const checkRule = (pattern) => pattern.test(password);

  const renderPasswordRules = () => (
    <List
      size="small"
      dataSource={passwordRules}
      renderItem={(rule) => (
        <List.Item>
          <span style={{ color: checkRule(rule.pattern) ? "green" : "red" }}>
            {checkRule(rule.pattern) ? <CheckCircleOutlined /> : <CloseCircleOutlined />} {rule.text}
          </span>
        </List.Item>
      )}
    />
  );

  const onPasswordChange = () => {
    const formData = {"password": password, "passwordConfirm": password};

    AuthRestAPI.resetPassword(urlToken, localStorage.getItem('groupId'), localStorage.getItem('companyId'), formData)
    .then((res) => {
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          navigate("/login");
        }, 7000);
    }).catch((err) => {
      console.log("error in change password :", err.message);
    })
  }

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Section */}
        <div className="left-section">
          <center>
            <h1 style={{fontWeight:'400'}}>
              mogu <br />
              <span>e-Invoicing System</span>
            </h1>
            <br />
            <br />
            <img src={Limage} style={{ width: "50%" }} alt="Left Section" />
          </center>
        </div>

        {/* Right Section */}
        <div className="border-container right-section" style={{ width: "50%" }}>
          <Button
            type="primary"
            className="card-button"
            style={{ pointerEvents: "none" }}
            size="large"
            icon={<SafetyOutlined />}
            shape="circle"
          ></Button>
          <Card className="right-card">
            <div
              className="logo"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <center>
                <Title level={1} className="logotext login-logo" style={{ fontSize: '4rem' }}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ width: 52, marginTop: -15 }}
                      src={Logo}
                      alt="Logo"
                    />{" "}
                    mogu
                  </span>
                </Title>
              </center>
            </div>
            {/* Success Alert */}
            {showSuccess && (
              <Alert
                //message="Success"
                description={
                  <span>
                    Your password has been successfully changed.{" "}
                    
                  </span>
                }
                type="success"
                showIcon
                style={{ marginBottom: 20 }}
              />
            )}
            <center>
              <h2>Change Password</h2>
              <p className="subtitle">
                To continue, please update your password. Enter your new password, then create and confirm your new password.
              </p>
            </center>
            <Form
              layout="vertical"
              onFinish={onFinish}
            >
              <Form.Item rules={[{ required: true, message: "Please input your Email" }]}>
                <Input
                  size="large"
                  name="email"
                  value={email}
                  disabled
                  placeholder="Email Address"
                  prefix={<UserOutlined style={{color:colorTextQuaternary}} />}
                />
              </Form.Item>

              <Popover
                content={renderPasswordRules()}
                title="Password Requirements"
                visible={popoverVisible}
              >
                <Form.Item
                  name="newpassword"
                  rules={[
                    {
                      validator: (_, value) => {
                        const isValid = passwordRules.every((rule) =>
                          rule.pattern.test(value)
                        );
                        return isValid
                          ? Promise.resolve()
                          : Promise.reject(
                              new Error(
                                "Password does not meet the requirements."
                              )
                            );
                      },
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="New Password"
                    prefix={<LockOutlined style={{color:colorTextQuaternary}} />}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onFocus={() => setPopoverVisible(true)}
                    onBlur={() => setPopoverVisible(false)}
                  />
                </Form.Item>
              </Popover>

              <Form.Item
                name="confirmpassword"
                dependencies={['newpassword']}
                rules={[
                  { required: true, message: "Please confirm your new password" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newpassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("The two passwords do not match!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="Confirm New Password"
                  prefix={<LockOutlined style={{color:colorTextQuaternary}} />}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" size="large" onClick={onPasswordChange} icon={<UnlockOutlined />} htmlType="submit" block>
                  Change Password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MoguLogin;
